import angular from 'angular';
import uiRouter from 'angular-ui-router';
import racedaysAddPageComponent from './racedaysAddPage.component';

let racedaysAddPageModule = angular.module('racedaysAddPage', [
  uiRouter
])

.component('racedaysAddPage', racedaysAddPageComponent)

.name;

export default racedaysAddPageModule;
